import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import { object, func, bool } from 'prop-types';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';

const styles = theme => ({
  component: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  barLayout: {
    padding: theme.spacing(1),
  },
  labelMarginTop: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  labelMarginBottom: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  checkRoot: {
    color: green[600],
    '&$checked': {
      color: green[500],
    },
  },
  checked: {},
});

const DeclarationOfApplicantComponent = ({
  classes,
  hasDeclared,
  hasReadTerms,
  declarationChanged,
  readTermsChanged,
}) => (
  <Translation>
    {t => {
      return (
        <div>
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('declarationOfApplicant')}
          </Typography>

          <Grid
            container
            spacing={3}
            alignItems="flex-start"
            justifyContent="center"
            direction="column"
            key="form-grid-container"
          >
            <Grid item xs={12}>
              <Grid
                container
                justifyContent="flex-start"
                className={classes.labelMarginTop}
              >
                <Grid>
                  <Checkbox
                    checked={hasDeclared}
                    onChange={e => declarationChanged(e.target.checked)}
                    value="checkedG"
                    classes={{
                      root: classes.checkRoot,
                      checked: classes.checked,
                    }}
                  />
                </Grid>
                <Grid>
                  <Typography
                    className={classes.barLayout}
                    variant="subtitle1"
                    align="left"
                    gutterBottom
                  >
                    {t('checkBox1')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="flex-start"
                className={classes.labelMarginBottom}
              >
                <Grid>
                  <Checkbox
                    checked={hasReadTerms}
                    onChange={e => readTermsChanged(e.target.checked)}
                    value="checkedG"
                    classes={{
                      root: classes.checkRoot,
                      checked: classes.checked,
                    }}
                  />
                </Grid>
                <Grid>
                  <Typography
                    className={classes.barLayout}
                    variant="subtitle1"
                    align="left"
                    gutterBottom
                  >
                    {t('checkBox2')}&nbsp;
                    <Link to="/toc">{t('termsAndConditions')}</Link>{' '}
                    {t('checkBox2And')}&nbsp;
                    <Link to="/privacy">{t('privacyPolicy')}</Link>.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }}
  </Translation>
);

DeclarationOfApplicantComponent.propTypes = {
  classes: object.isRequired,
  hasDeclared: bool,
  declarationChanged: func.isRequired,
  hasReadTerms: bool,
  readTermsChanged: func.isRequired,
};

export default withStyles(styles)(DeclarationOfApplicantComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/DeclarationOfApplicant/index.js